import React from 'react';
import './ContactsPage.css'
import { languageManager } from '../../utils/i18n';

const ContactsPage = () => {
	const t = languageManager.t.bind(languageManager);

	return (
		<div className='contacts_page'>
			<div className="contacts_container">
				<h1 className='contacts_address'  dangerouslySetInnerHTML={{ __html: t('contacts.address')}}></h1>
				<div className="contacts_links">
					<a href="mailto:kudriavka@kovalska.com">kudriavka@kovalska.com</a>
					<a href="https://www.instagram.com/kudriavka.kyiv/" target='_blank'>instagram</a>
				</div>
			</div>
		</div>
	)
};

export default ContactsPage;